import { all } from "redux-saga/effects";
import watchFetchSpicesAsync from "./spicesSaga";
import watchFetchIncensesAsync from "./incensesSaga";
import watchFetchContactsAsync from "./contactsSaga";
import watchUserLoginAsync from "./userLoginSaga";
import watchUserLogoutAsync from "./userLogoutSaga";
import watchFetchOrdersAsync from "./ordersSaga";
import watchOrderStatusAsync from "./orderStatusSaga";

export default function* rootSaga() {
  yield all([
    watchFetchSpicesAsync(),
    watchFetchIncensesAsync(),
    watchFetchContactsAsync(),
    watchUserLoginAsync(),
    watchUserLogoutAsync(),
    watchFetchOrdersAsync(),
    watchOrderStatusAsync(),
  ]);
}
